import AdAccountSetup from "./AdAccountSetup";
import React, {useState} from "react";
import {useFacebookConfig} from "crqlar-react-common/dist/utils/hooks/meta/useFacebookConfig";
import AdAccountDetails from "./AdAccountDetails";
import SettingsPageHeader from "../layout/SettingsPageHeader";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

const MetaConnectorSettings = () => {
    const facebookConfig = useFacebookConfig()
    const [navigateDirectlyToAdAccount, setNavigateDirectlyToAddAccount] = useState(false)
    const {t} = useTranslation()
    const navigate = useNavigate()

    return(
        <>
            <SettingsPageHeader
                title={t('Meta connector')}
                back={() => navigate('/system')}
            />
            {
                (facebookConfig?.accessToken && facebookConfig?.adAccountId) ?
                    (
                        <AdAccountDetails setNavigateDirectlyToAdAccount={setNavigateDirectlyToAddAccount}/>
                    )

                    :

                    (
                        <AdAccountSetup
                            navigateDirectlyToAdAccount={navigateDirectlyToAdAccount}
                        />
                    )
            }
        </>
    )
}

export default MetaConnectorSettings
